module.exports = JitsiMeetExternalAPI;